import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ModalTopBg } from '@styles';
import { SpinNoticeFilled } from '@assets';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
}

.ant-modal-content {
	text-align: center;
    padding-top: 120px !important;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn-default {
        display: none !important;
    }
}

#modal-icon {
    width: 100px !important;
    top: -10px !important;
}
`;

const Box = styled.div`
display: flex;
height: 50px;
padding: 8px 16px;
justify-content: center;
align-items: center;
background: linear-gradient(90deg, rgba(255, 214, 71, 0.00) 0%, #FFD647 50%, rgba(255, 214, 71, 0.00) 100%);
backdrop-filter: blur(25px);

font-size: 20px;
font-weight: 700;
color: #1e1e1e;
`;

const SpinAlert = ({
    open,
    title,
    description,
    isError,
    onOk,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            title={title}
            open={open}
            onOk={onOk}
            okText={t('common.ok')}
        >
            <ModalTopBg />
            <SpinNoticeFilled id='modal-icon' />
            {isError ? description : <Box>{description}</Box>}
        </Modal>
    );
}

export default SpinAlert;